// src/runtime/bootstrap.ts
import { loadSolcatcherConfig } from "../config/loadConfig.js";
import { loadEnvFromConfig } from "./../env/loadEnv.js";

let bootstrapped = false;

export function solanaBootstrapEnv() {
  if (bootstrapped) return;
  bootstrapped = true;

  const config = loadSolcatcherConfig();
  loadEnvFromConfig(config);
}